import axiosInstance from "../../axiosInstance";
import { normalizeApiError } from "../../../utils/normalizeApiError";
import { UpdateProjectPayload } from "types/project/updateProject";
import { CreateProjectApiResponse, ProjectSuccessResponse } from "../../../types/createProject";

export const updateProject= async (
    payload:UpdateProjectPayload
):Promise<ProjectSuccessResponse>=>{
    try {
        const { data }=await axiosInstance.post<CreateProjectApiResponse>(
            '/pmo/update-project',
            payload
        );
        if (data.response.status === false) {
            throw data;
        }

        return data.response;
        
    } catch (error) {
        throw normalizeApiError(error);        
    }

};
